<script lang="ts">
	export let replaceText: (text: string, unit: number, usePoint: boolean) => string;
	export let handleClickCopy: () => void;

	let usePoint = false;
	let unit = 0.001;
	let inputText = "[2001年9月10日1時32分41秒] 何かが起きた\n[2020-03-12T12:32:41.123456+09:00] 別の何かが起きた\n[2020-03-12T12:32:41.123456789Z] すごい何かが起きた\n[20200512 123241 +0900] こんなのも行ける";
	let outputText = "";
	function handleClickReplace() {
		outputText = replaceText(inputText, unit, usePoint);
	}
</script>

<main>
	<h1>日付文字列をタイムスタンプに置換</h1>
	<h2>
		<a href="/app/timestamp-string-converter/">逆バージョンはこちら</a>
	</h2>
	<h2>説明</h2>
	<p>
		2000年以降の時刻を表しているっぽい文字列を見つけたらUnixタイムスタンプに置換してくれるよ。<br>
		ログファイルを貼り付けて置換してみよう！！<br>
		<a href="/posts/timestamp-converter/">作ってみたときのブログ記事はこちら</a>
	</p>
	<p>
		<input type="radio" bind:group={unit} value={0.001}> 秒精度
		<input type="radio" bind:group={unit} value={1}> ミリ秒精度
		<input type="radio" bind:group={unit} value={1000}> マイクロ秒精度
		<input type="radio" bind:group={unit} value={1000000}> ナノ秒精度
	</p>
	<p>
		<input type="checkbox" bind:checked={usePoint}> 小数点を入れる
	</p>
	<p>
		<textarea id="input-text" cols="120" rows="10" bind:value={inputText}></textarea>
	</p>
	<p>
		<button on:click={handleClickReplace}>置換する</button>
		<button on:click={handleClickCopy}>コピーする</button>
	</p>
	<p>
		<textarea id="output-text" cols="120" rows="10" readonly bind:value={outputText}></textarea>
	</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	textarea {
		max-width: 100%;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>